import { createContext } from 'react';
import { AnimationHandlersType, AnimationType } from './types';

export const AnimationContext = createContext<AnimationType | undefined>(undefined);

export const AnimationHandlersContext = createContext<AnimationHandlersType | undefined>(undefined);
